import {Component, ElementRef, HostListener, OnDestroy, OnInit} from '@angular/core';
import {LoanApplicationService} from '../loan-application/loan-application.service';
import {Router} from '@angular/router';
import {LoanApplication} from '../../@models/loan-application.model';

@Component({
  selector: 'bb-seaman-loan',
  templateUrl: './seaman-loan.component.html',
  styleUrls: ['./seaman-loan.component.scss'],
})
export class SeamanLoanComponent implements OnInit, OnDestroy {
  control = this.loanApplicationService.form.get('employment_info.employment_type');
  seaman = LoanApplication.EmploymentType.sea;
  body = this.elementRef.nativeElement.ownerDocument.body;
  screenWidth = window.screen.width;

  constructor(private elementRef: ElementRef,
              public loanApplicationService: LoanApplicationService,
              private route: Router) {
  }

  ngOnInit() {
    this.control.setValue(this.seaman);
    this.setBackground(this.screenWidth);
  }

  setBackground(screenWidth) {
    if (screenWidth <= 1024) {
      this.body.style.backgroundImage = 'url(/assets/img/top/index_seaman_0w.jpg)';
      this.body.style.overflowY = 'scroll';
    } else {
      this.body.style.backgroundImage = 'url(/assets/img/top/index_seaman_990w.jpg)';
      this.body.style.overflowY = 'hidden';
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    const width = event.target.innerWidth;
    this.setBackground(width);
  }

  ngOnDestroy() {
    if (this.route.url !== '/seaman-loan') {
      this.body.style.backgroundImage = null;
    }
    this.body.style.overflowY = 'unset';
  }
}
